import { useEffect, useMemo, useReducer, useRef } from 'react'

import {
  Button,
  Heading,
  ImageWrap,
  Text,
  theme,
  useHealthToolsCache,
} from '@hhgtech/hhg-components'
import { CommonGAssets } from '@hhgtech/hhg-components/gAssets'
import { Box, Flex, rem, Stack } from '@mantine/core'
import classNames from 'classnames'
import { useIntl } from 'react-intl'

import InvisibleIcon from '@/public/svg/invisible.svg'
// import Share from 'components/atoms/icons/Share'
import { AdBlock } from 'components/molecules/adBlock'
import { AdBlockContainer } from 'components/molecules/adBlock/adBlockContainer'
import { FixedBottomAdBlock } from 'components/molecules/adBlock/fixedBottomAdBlock'
import { HealthToolBreadcrumb } from 'components/molecules/healthToolBreadcrumb'
import { AdditionalInfo } from 'components/molecules/healthTools/additionalInfo'
import { ToolsSuggestionArticles } from 'components/molecules/toolsSuggestionArticles'
import { SharePopupNew } from 'components/organisms/sharePopupNew'
import { VideoList } from 'components/organisms/videoLists'
import { OutOfPageAd } from 'components/pages/article/components/OutOfPageAd'
import { HealthToolLayout } from 'components/templates/healthToolLayout'
import { OvulationInfo } from 'components/templates/ovulationCalculator/ovulationInfo'
import { useCurrentUrl } from 'hooks/useCurrentUrl'
import { useIsMobile } from 'hooks/useIsMobile'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { basePath } from 'interfaces/constants'
import { HEALTH_TOOL_TYPE } from 'interfaces/constants/healthTools'
import { BabyPoopPage } from 'interfaces/types'
import { useModalStore } from 'state/modal'
import { getAdTag, getCountryAdTag, getLocaleCategoryAdTag } from 'utils/ads'

import {
  StyledBabyPoopDetail,
  StyledBabyPoopDetailBackButton,
  StyledBabyPoopDetailImageFloatContent,
  StyledBabyPoopDetailImageWrapper,
  StyledBabyPoopDetailMainColumn,
  StyledBabyPoopDetailPoopImage,
} from './index.styled'
import FrisoOnboarding, { FrisoModalHandle } from '../../frisoOnboarding'
import { StyledSuggestedArticlesContainer } from '../../index.styled'
import { OnboardingFlow } from '../../onboarding/onboardingFlow'
import { BabyPoopHeader } from '../components'
import {
  StyledBabyPoopInfo,
  StyledBabyPoopInnerContent,
  StyledBabyPoopSignatureColorBar,
} from '../components/index.styled'
import { colorMap } from '../helpers'

export type Props = {
  babyPoopPage: BabyPoopPage
  isVN: boolean
}
const BabyPoopDetail = ({ babyPoopPage, isVN }: Props) => {
  const { formatMessage: f } = useIntl()
  const isMobile = useIsMobile()

  const {
    locale,
    asPath,
    router: { query, replace, push },
  } = useRouterExtend()
  const { getHealthToolLink } = useHealthToolsCache(locale)
  const setShouldOnboardingModalOpen = useModalStore(
    (state) => state.setShouldOnboardingModalOpen,
  )
  const currentUrl = useCurrentUrl()
  const frisoModalRef = useRef<FrisoModalHandle>(null)
  const showFrisoCollectingForm =
    process.env.NEXT_PUBLIC_ENABLE_FRISO_COMPAIGN === 'true'

  // const [isShareOpen, setIsShareOpen] = useState(false)
  const [isBlurred, toggleIsBlurred] = useReducer((b) => !b, true)
  const adUnitPath = getAdTag({
    countryAdTag: getCountryAdTag(locale, {
      isMobile,
    }),
    contentAdTag: getLocaleCategoryAdTag(locale, asPath, [
      'health-tools/baby-poop',
    ]) || {
      result: 'HealthTools',
      redundant: true,
    },
  })
  const enabledAd = !!babyPoopPage?.enable_ad

  const item = useMemo<
    BabyPoopPage['result'][number] | undefined | null
  >(() => {
    if (!query.type) {
      return null
    }

    return babyPoopPage.result.find(
      (poop) =>
        poop.name === query.type ||
        poop.name === decodeURI(String(query.type)) ||
        null,
    )
  }, [query.type])

  useEffect(() => {
    !showFrisoCollectingForm && setShouldOnboardingModalOpen(true)
  }, [babyPoopPage])

  useEffect(() => {
    if (!item) {
      replace(getHealthToolLink(HEALTH_TOOL_TYPE.BABY_POOP))
      return
    }

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }, [item])

  if (!item) {
    return null
  }

  // const onShare = () => {
  //   if (isMobile) {
  //     setIsShareOpen(true)
  //   }
  // }

  // const onCopied = () => {
  //   showNotification({
  //     type: 'success',
  //     title: 'Success',
  //     message: 'Link copied successfully',
  //   })
  // }
  const pageItem = [
    {
      label: f({ id: 'healthtools.title' }),
      value: `/health-tools`,
    },
    {
      label: f({
        id: 'babyPoop.breadcrumbs',
        defaultMessage: 'Baby Poop',
      }),
      value: `${getHealthToolLink(HEALTH_TOOL_TYPE.BABY_POOP)}`,
    },
  ]
  return (
    <>
      {/* {isMobile && (
        <ShareDrawer
          locale={locale}
          url={currentUrl}
          open={isShareOpen}
          onClose={() => setIsShareOpen(false)}
          onCopied={onCopied}
          onShared={() => setIsShareOpen(false)}
        />
      )} */}
      <StyledBabyPoopDetail>
        {!isMobile && isVN && <HealthToolBreadcrumb pageItem={pageItem} />}

        {babyPoopPage.sponsorBanner?.showSponsorBanner && (
          <BabyPoopHeader
            isVN={isVN}
            pageItem={pageItem}
            babyPoopPage={babyPoopPage}
          />
        )}
        <HealthToolLayout>
          <HealthToolLayout.LeftColumn>
            <StyledBabyPoopDetailMainColumn>
              <Stack spacing={rem(32)}>
                <Box>
                  <StyledBabyPoopDetailImageWrapper data-is-blurred={isBlurred}>
                    <StyledBabyPoopDetailPoopImage
                      src={item.image}
                      alt={item.titleResult}
                    />

                    <StyledBabyPoopDetailImageFloatContent>
                      <InvisibleIcon />

                      <div>
                        <Text
                          size="s3"
                          type="semiBold"
                          color={theme.colors.white}
                        >
                          {f({
                            id: 'babyPoop.contentWarningMessage',
                            defaultMessage:
                              'Warning content: Sensitive content',
                          })}
                        </Text>

                        <Text
                          size="p4"
                          color={theme.colors.white}
                          className="mt-4"
                        >
                          {f({
                            id: 'babyPoop.contentWarningDescription',
                            defaultMessage: `This image may be sensitive`,
                          })}
                        </Text>

                        <Button
                          color="primary"
                          size="sm"
                          onClick={toggleIsBlurred}
                          className="mt-4"
                        >
                          {f({
                            id: isBlurred
                              ? 'babyPoop.image.unblur'
                              : 'babyPoop.image.blur',
                            defaultMessage: isBlurred ? 'Show' : 'Blur',
                          })}
                        </Button>
                      </div>
                    </StyledBabyPoopDetailImageFloatContent>
                  </StyledBabyPoopDetailImageWrapper>
                  <StyledBabyPoopSignatureColorBar
                    signatureColor={colorMap[item.color].displayColor}
                    width={168}
                    className="mt-4"
                  />
                  <Text size="s1" type="semiBold" className="mt-4">
                    {item.titleResult}
                  </Text>
                  <Text size="p4" color={theme.colors.gray600} className="mt-1">
                    {item.textInput}
                  </Text>

                  <Text size="s2" type="semiBold" className="mt-6">
                    {f({
                      id: 'babyPoop.describle',
                      defaultMessage: 'Describle',
                    })}
                  </Text>
                  <StyledBabyPoopInnerContent
                    className="mt-2"
                    dangerouslySetInnerHTML={{
                      __html: item.description,
                    }}
                  />

                  <Text size="s2" type="semiBold" className="mt-6">
                    {f({
                      id: 'babyPoop.whatShouldDo',
                      defaultMessage: 'What should I do?',
                    })}
                  </Text>
                  <StyledBabyPoopInnerContent
                    className="mt-2"
                    dangerouslySetInnerHTML={{
                      __html: item.whatShouldIDo,
                    }}
                  />
                </Box>
                {process.env.NEXT_PUBLIC_ENABLE_FRISO_COMPAIGN === 'true' && (
                  <Box
                    sx={{ cursor: 'pointer' }}
                    onClick={() => frisoModalRef?.current?.open?.()}
                  >
                    <ImageWrap
                      alt=""
                      src={CommonGAssets.getAssetPath(
                        isMobile
                          ? 'friso/wide-banner-mobile.jpg'
                          : 'friso/wide-banner.jpg',
                      )}
                    ></ImageWrap>
                  </Box>
                )}
                <AdditionalInfo
                  heading={babyPoopPage.additionalInfo.title}
                  content={babyPoopPage.additionalInfo.description}
                  ctaUrl={babyPoopPage.additionalInfo.ctaUrl}
                  ctaTitle={babyPoopPage.additionalInfo.ctaTitle}
                  image={babyPoopPage.additionalInfo.image}
                />
                <Box>
                  {isMobile ? (
                    <div className="inline-button">
                      {/* <Button
                        size="sm"
                        color="tertiary"
                        className="share"
                        data-event-category="Health Tool"
                        data-event-action="Baby Growth Result Share"
                        data-event-label={currentUrl}
                        onClick={onShare}
                      >
                        <Share />
                      </Button> */}
                      <Button
                        color="secondary"
                        size="sm"
                        onClick={() =>
                          push(
                            `${
                              window.location.origin
                            }${basePath}${getHealthToolLink(
                              HEALTH_TOOL_TYPE.BABY_POOP,
                            )}`,
                          )
                        }
                      >
                        {f({
                          id: 'riskScreener.back',
                          defaultMessage: 'Back',
                        })}
                      </Button>
                    </div>
                  ) : (
                    <div>
                      {/* <ShareContainer
                        url={currentUrl}
                        onCopied={onCopied}
                        locale={locale}
                      /> */}
                      <Flex justify={'center'}>
                        <SharePopupNew.BottomNavHorizonal
                          shareUrl={currentUrl}
                          showFull
                          iconSize={24}
                          styles={{
                            heading: {
                              fontSize: 12,
                            },
                          }}
                        />
                      </Flex>
                      <StyledBabyPoopDetailBackButton>
                        <Button
                          color="secondary"
                          size="sm"
                          className={classNames('mx-auto', 'mt-[24px]')}
                          onClick={() =>
                            push(
                              `${
                                window.location.origin
                              }${basePath}${getHealthToolLink(
                                HEALTH_TOOL_TYPE.BABY_POOP,
                              )}`,
                            )
                          }
                        >
                          {f({
                            id: 'riskScreener.back',
                            defaultMessage: 'Back',
                          })}
                        </Button>
                      </StyledBabyPoopDetailBackButton>
                    </div>
                  )}
                  <VideoList
                    title={f({
                      id: 'babyPoop.video.title',
                      defaultMessage: 'Làm Mẹ nhẹ tênh, chẳng lo bé Táo Bón',
                    })}
                    videos={babyPoopPage.sponsorBanner?.videoBlock?.listVideo}
                  />
                  {babyPoopPage.disclaimer && (
                    <OvulationInfo
                      heading={f({ id: 'ovulationPage.disclaimer' })}
                      content={babyPoopPage.disclaimer}
                      className="mt-6"
                    />
                  )}

                  {!!item.faqs.length && (
                    <StyledBabyPoopInfo
                      className="faqs-block"
                      heading={f({ id: 'tools.faqs' })}
                      infos={item.faqs}
                      withDisclaimer={!!babyPoopPage.disclaimer}
                    />
                  )}

                  {isMobile && (
                    <>
                      {enabledAd && (
                        <div
                          className="top-ad my-[16px]"
                          style={{
                            minHeight: 250,
                          }}
                        >
                          <AdBlock
                            adUnitPath={adUnitPath}
                            size={[
                              [300, 250],
                              [300, 600],
                            ]}
                            divId={'div-gpt-ad-midbanner1-mobile'}
                            pos={['MidBanner1']}
                          />
                        </div>
                      )}

                      {!!item.recommendArticles?.length && (
                        <StyledSuggestedArticlesContainer
                          className={classNames({
                            'mx-[-16px]': isMobile,
                          })}
                        >
                          <Heading
                            tag="h3"
                            color={theme.colors.gray800}
                            style={{ width: '100%', padding: '8px 16px' }}
                          >
                            {f({
                              id: 'tools.suggestedArticles',
                              defaultMessage: 'Suggested articles',
                            })}
                          </Heading>
                          <ToolsSuggestionArticles
                            isMobile
                            expertsArticles={item.recommendArticles}
                            hideUIElements
                          />
                        </StyledSuggestedArticlesContainer>
                      )}
                    </>
                  )}
                </Box>
              </Stack>
            </StyledBabyPoopDetailMainColumn>
          </HealthToolLayout.LeftColumn>
          <HealthToolLayout.RightColumn>
            {!isMobile ? (
              <div className="pl-4">
                {enabledAd && (
                  <div
                    className="top-ad"
                    style={{
                      minHeight: 250,
                    }}
                  >
                    <AdBlock
                      adUnitPath={adUnitPath}
                      size={[
                        [300, 250],
                        [300, 600],
                      ]}
                      divId={'div-gpt-ad-midbanner1-desktop'}
                      pos={['MidBanner1']}
                    />
                  </div>
                )}

                {!!item.recommendArticles?.length && (
                  <StyledSuggestedArticlesContainer>
                    <Heading
                      tag="h3"
                      color={theme.colors.gray800}
                      style={{ width: '100%', padding: '8px 16px' }}
                    >
                      {f({
                        id: 'tools.suggestedArticles',
                        defaultMessage: 'Suggested articles',
                      })}
                    </Heading>
                    <ToolsSuggestionArticles
                      isMobile
                      expertsArticles={item.recommendArticles}
                      hideUIElements
                    />
                  </StyledSuggestedArticlesContainer>
                )}
              </div>
            ) : undefined}
          </HealthToolLayout.RightColumn>
        </HealthToolLayout>
        {isMobile && <HealthToolBreadcrumb pageItem={pageItem} />}
        <OnboardingFlow
          campaign={babyPoopPage.collectingData.campaigns}
          isSkippable={babyPoopPage?.isSkippable}
          typeForm={babyPoopPage?.collectingTypes}
          phoneVerify={babyPoopPage?.phoneVerification}
        />

        {enabledAd && (
          <>
            <AdBlockContainer>
              <FixedBottomAdBlock
                adUnitPath={adUnitPath}
                className="article-bottom-ad"
                isMobile={isMobile}
              />
            </AdBlockContainer>
            <OutOfPageAd id={`div-gpt-out-of-page`} adUnitPath={adUnitPath} />
          </>
        )}
      </StyledBabyPoopDetail>
      {showFrisoCollectingForm && (
        <FrisoOnboarding
          ref={frisoModalRef}
          type={String(query.type)}
          isModal
        />
      )}
    </>
  )
}

export { BabyPoopDetail }
